module.exports = __webpack_public_path__ + "img/23. Close.bdb0a88d.svg";